<template>
    <div>
        <div class="columns" id="table">
            <div class="field is-horizontal" v-if="isMobile && searchResults.length">
                <div class="field-label is-normal">
                    <label class="label">Sort By <input id="sortOrder" type="checkbox" v-model="sortOrder" class="switch is-rounded" checked="checked">
                        <label for="sortOrder">Desc</label></label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <div class="sort-select select is-fullwidth">
                                <select v-model="selectedSort" v-on:change="sortAuction()">
                                    <option v-for="sortBy in getSortBy" :value="sortBy.name">{{ sortBy.text }}</option>
                                </select>
                                <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <advance-search-result-mobile
                v-if="isMobile"
                v-for="(lot, index) in searchResults"
                :lot="lot"
                :index="index"
                v-bind:key="index">
            </advance-search-result-mobile>
            <div  v-if="!isMobile" class="column">
                <div class="theme-table-container table-container center-column">
                    <table class="buy-now-table auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth" id="table">
                        <thead>
                        <tr class="top-header" id="resultTable">
                            <th></th>
                            <th @click=" orderBy('lot_date')"><span class="link">Date</span></th>
                            <th @click=" orderBy('auction_name')"><span class="link">Place</span></th>
                            <th @click=" orderBy('model_name_en')"><span class="link">Model</span></th>
                            <th></th>
                            <th @click=" orderBy('model_type_en')"><span class="link">Chassis</span></th>
                            <th @click=" orderBy('mileage_num')"><span class="link">Mileage</span></th>
                            <th @click=" orderBy('color_en')"><span class="link">Color</span></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>

                        </tr>
                        <tr class="bottom-header">
                            <th>Photo</th>
                            <th>Time</th>
                            <th @click=" orderBy('bid')"><span class="link">Lot No</span></th>
                            <th @click=" orderBy('grade_en')"><span class="link">Grade</span></th>
                            <th @click=" orderBy('model_year_en')"><span class="link">Year</span></th>
                            <th @click=" orderBy('displacement_num')"><span class="link">Engine Size</span></th>
                            <th @click=" orderBy('transmission_en')"><span class="link">Transmission</span></th>
                            <th @click=" orderBy('scores')"><span class="link">Score</span></th>
                            <th>Market Price</th>
                            <th @click=" orderBy('start_price')"><span class="link">Start/Price</span></th>
                            <th @click=" orderBy('result')"><span class="link">Result</span></th>
                            <th>Bid</th>
                        </tr>
                        </thead>
                        <tbody>
                        <advance-result-table-row v-for="(lot, index) in searchResults" :lot="lot" :index="index" v-bind:key="index"></advance-result-table-row>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="columns" v-if="hasLots">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                        <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
        <bid-modal v-if="biddingModalActive"></bid-modal>
        <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>
        <market-price></market-price>
    </div>
</template>

<script>
    import AdvanceResultTableRow from './AdvanceResultTableRow.vue'
    import BidModal from './../BiddingModal/BidModal'
    import AdvanceSearchResultMobile from "./AdvanceSearchResultMobile";
    import MarketPrice from "../../Lot/Details/MarketPrice";
    import Gallery from './Gallery'
    export default {
        components: {
            AdvanceSearchResultMobile,
            AdvanceResultTableRow,
            Gallery,
            BidModal,
            MarketPrice
        },
        data() {
            return {

                getSortBy:[
                    { name: 'lot_date', text: 'Date'},
                    { name: 'auction_name', text: 'Place'},
                    { name: 'model_name_en', text: 'Model'},
                    { name: 'model_type_en', text: 'Chassis'},
                    { name: 'mileage_num', text: 'Mileage'},
                    { name: 'color_en', text: 'Color'},
                    { name: 'bid', text: 'Lot No'},
                    { name: 'grade_en', text: 'Grade'},
                    { name: 'model_year_en', text: 'Year'},
                    { name: 'displacement_num', text: 'Engine Size'},
                    { name: 'transmission_en', text: 'Transmission'},
                    { name: 'scores', text: 'Score'},
                    { name: 'start_price', text: 'Start/Price'},
                    { name: 'result', text: 'Result'},
                ]
            }
        },
        computed: {
            selectedSort:{
                get(){
                    return this.$store.getters.getResultOrderColumn
                },
                set(value){
                    this.$store.dispatch('setResultOrderColumn', value)
                    this.$store.dispatch('fetchResults')
                }
            },
            sortOrder: {
                get(){
                    return this.$store.getters.getResultOrderType == 'DESC' ? true : false
                },
                set(value){
                    if(value){
                        this.$store.dispatch('setResultOrderType', 'DESC')
                    }else{
                        this.$store.dispatch('setResultOrderType', 'ASC')
                    }
                    this.$store.dispatch('fetchResults')
                }
            },
            searchResults() {
                return this.$store.getters.getSearchResults
            },
            isLastPage() {
                return this.$store.getters.isSearchResultsLastPage
            },
            getCurrentPage() {
                return this.$store.getters.getSearchResultsCurrentPage
            },
            getFirstPage() {
                return this.$store.getters.getSearchResultsFirstPage
            },
            getLastPage() {
                return this.$store.getters.getSearchResultsLastPage
            },
            hasLots() {
                return this.$store.getters.getSearchResults.length > 0
            },
            biddingModalActive() {
                return this.$store.getters.getResultActiveBiddingModalStatus
            },
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        },
        methods: {
            orderBy(column){
                this.$store.getters.getResultOrderType === 'ASC' ? this.$store.dispatch('setResultOrderType', 'DESC') : this.$store.dispatch('setResultOrderType', 'ASC')
                this.$store.dispatch('setResultOrderColumn', column)
                this.$store.dispatch('fetchResults')
            },
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            changePage(page) {
                let table = document.getElementById("table");
                table.scrollIntoView();
                this.$store.dispatch('loadMoreResults', page)
            },
            sortAuction(){
                this.$store.getters.getResultOrderType === 'ASC' ? this.$store.dispatch('setResultOrderType', 'DESC') : this.$store.dispatch('setResultOrderType', 'ASC')
                this.$store.dispatch('setResultOrderColumn', column)
                this.$store.dispatch('fetchResults')
            }
        },
    }
</script>

<style scoped>
    th {
        font-size: 10px;
    }
    .top-header th {
        border-bottom: none;
        background-color: whitesmoke;
    }
    .bottom-header th {
        border-top: none;
        background-color: whitesmoke;
    }
    .link:hover {
       cursor: pointer;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }

    table {
        border-collapse: collapse;
        margin: 0;
        padding: 0;
    }

    @media only screen and (max-width: 600px) {
        .columns {
            padding: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Result/AdvanceSearchResult.vue